import React, { useState, useEffect, useRef } from 'react';
import style from "./Loginnew.module.css";
import { login_Api, signup_Api, verifycode } from '../dashboardapi';
import { Link, useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import CaptchaCanvas from "./Captcha"
import { setToken } from '../Utils/authUtils';
const Loginnew = () => {
    const [confirmpassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [render, setRender] = useState(false);
    const [captcha, setCaptcha] = useState("");
    const [generatedCaptcha, setGeneratedCaptcha] = useState("");
    const [forgetPassword, setForgetPassword] = useState(false);
    const [verification, setVerification] = useState(false);
    const [changingPassword, setChangingPassword] = useState(false);
    const [verifyEmail, setVerifyEmail] = useState("");
    const inputRefs = useRef([]);
    const [otp, setOtp] = useState(Array(6).fill(""));
    const navigate = useNavigate();
    const toast = useToast();
    const [activeIndex, setActiveIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    // Generate random captcha
    const generateCaptcha = () => {
        const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789abcdefghijklmnopqrstuvwxyz";
        let code = "";
        for (let i = 0; i < 6; i++) {
            code += chars[Math.floor(Math.random() * chars.length)];
        }
        setGeneratedCaptcha(code);
    };
    // useEffect(() => {
    //     if (verification) {
    //         if (inputRefs.current[0]) {
    //             inputRefs.current[0].focus();
    //         }
    //     }
    // }, [verification]);


    useEffect(() => {
        generateCaptcha();
    }, []);

    // const getRedirectPath = () => {
    //     const params = new URLSearchParams(window.location.search);
    //     return "/dashboard/myprojects" || params.get("redirect");
    // };
    const getRedirectPath = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get("redirect") || "/dashboard/myprojects";
    };


    const handleChange = (value, index) => {
        if (!/^[0-9]?$/.test(value)) return; // Only allow single digit

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next box automatically
        if (value !== "" && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (otp[index] === "" && index > 0) {
                inputRefs.current[index - 1].focus();
            }
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const data = e.clipboardData.getData("text");
        const numbers = data.replace(/\D/g, "").slice(0, 6).split("");

        const newOtp = [...otp];
        numbers.forEach((num, i) => {
            newOtp[i] = num;
        });

        setOtp(newOtp);

        // Focus last filled input
        const lastIndex = numbers.length - 1;
        if (inputRefs.current[lastIndex]) {
            inputRefs.current[lastIndex].focus();
        }
    };

    const handleSignIn = async (e) => {
        e.preventDefault();

        // Captcha validation
        if (captcha.trim().toUpperCase() !== generatedCaptcha.toUpperCase()) {
            toast({
                title: "Invalid Captcha",
                description: "Please enter the correct characters.",
                status: "error",
                duration: 2000,
                isClosable: true
            });
            generateCaptcha();
            setCaptcha("");
            return;
        }
        setLoading(true);
        let result = await login_Api(email, password);

        if (result.data) {
            toast({
                title: "Sign In Successful",
                description: "You have successfully signed in.",
                status: "success",
                duration: 2000,
                isClosable: true
            });

            setToken(result.data.token);
            setEmail("");
            setPassword("");
            setCaptcha("");

            navigate(getRedirectPath());
            setLoading(false)
        } else {
            toast({
                title: "Login Failed",
                description: result.error?.detail || "Invalid email or password.",
                status: "error",
                duration: 2000,
                isClosable: true
            });
            setLoading(false);
        }
    };
    const handleSignUp = async (e) => {
        e.preventDefault();
        try {
            let result = await signup_Api("signIn", email, password, confirmpassword);
            if (result.data) {
                if (result.data.status === "email") {
                    toast({
                        title: "Verification Code sent to your email",
                        description: result.data.message,
                        status: "success",
                        duration: 2000,
                        isClosable: "true"
                    })
                    setVerification(true)
                    setForgetPassword(false);
                    // if (loginpages === "signIn") {
                    //     navigate("/loginnew/signIn/verifyCode")
                    // } else {
                    //     navigate("/loginnew/signUp/verifyCode")
                    // }
                }
                if (result.data.status === "complete") {
                    toast({
                        title: "",
                        description: result.data.message,
                        status: "success",
                        duration: 2000,
                        isClosable: "true"
                    })
                    // navigate("/loginnew/signIn")

                }
            } else {
                let error = result.error.message
                toast({
                    title: "signUp failed",
                    description: error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        } catch (error) {
            toast({
                title: "signUp failed",
                description: "Failed to signUp please try again",
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const handleChangePassword = async (e) => {
        e.preventDefault();
        try {
            let result = await signup_Api("signIn", email, password, confirmpassword);
            if (result.data) {
                if (result.data.status === "email") {
                    toast({
                        title: "Verification Code sent to your email",
                        description: result.data.message,
                        status: "success",
                        duration: 2000,
                        isClosable: "true"
                    })


                    // if (loginpages === "signIn") {
                    //     navigate("/loginnew/signIn/verifyCode")
                    // } else {
                    //     navigate("/loginnew/signUp/verifyCode")
                    // }
                }
                if (result.data.status === "complete") {
                    toast({
                        title: "",
                        description: result.data.message,
                        status: "success",
                        duration: 2000,
                        isClosable: "true"
                    })
                    setEmail("");
                    setPassword("");
                    setCaptcha("");
                    setConfirmPassword("")
                    setChangingPassword(false);
                    setVerification(false);
                    setForgetPassword(false);
                    // navigate("/loginnew/signIn")
                }
            } else {
                let error = result.error.message
                toast({
                    title: "signUp failed",
                    description: error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        } catch (error) {
            toast({
                title: "signUp failed",
                description: "Failed to signUp please try again",
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const verifycodeapi = async (e) => {
        e.preventDefault();
        // const enteredCode = otp.join("");
        console.log(otp)
        // setCode(enteredCode);
        setRender(render)

        let result = await verifycode("signIn", email, otp.join(""))
        if (result.data) {
            // console.log(result.data);
            toast({
                title: "Code verified successfully",
                status: "success",
                duration: 2000,
                isClosable: true,
            })
            setChangingPassword(true)
            setVerification(false);

            // navigate(`/loginnew/${loginpages}/confirmPassword`)
        } else {
            let error = result.error.message
            toast({
                title: 'Verification unsuccessfull',
                description: error,
                status: 'error',
                duration: 2000,
                isClosable: "true"
            })

        }
    }

    return (
        <main>
            <div className="container">
                <div className={style.signinpagecontainer}>

                    <div className={style.firsthalf}>

                        <div className={style.loginlogocontainer}>
                            <Link to={"/home"}>

                                <img
                                    src={process.env.PUBLIC_URL + "/NewPages/Homepage/TransformaLogo.png"}
                                    alt="Transforma Logo"
                                    className={style.LoginLogo}
                                />
                            </Link>
                        </div>
                        {
                            (!forgetPassword && !verification && !changingPassword) && (
                                <div className={style.formcontainer}>
                                    <div style={{ "textAlign": "center" }} className={style.signinTitle}>
                                        <h1>Welcome back!</h1>
                                        <p>Enter your details to sign in</p>
                                    </div>

                                    <form onSubmit={handleSignIn}>

                                        <div className={style.logincombine}>
                                            <label>Email *</label>
                                            <input
                                                type="email"
                                                placeholder="e.g. devdes@gmail.com"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className={style.logincombine}>
                                            <div className={style.loginforgetpassword}>
                                                <label>Password *</label>
                                                <p style={{}} className={style.forgetPassword} onClick={() => { setForgetPassword(true) }}>Forget Password</p>
                                            </div>
                                            <div className={style.passwordContainer}>


                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Enter your password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required
                                                />
                                                <div className={style.eyeIcon} >
                                                    <button
                                                        aria-label={showPassword ? "Hide password" : "Show password"}
                                                        name="showpasswordbutton" style={{ background: "transparent", margin: "0px" }} className={style.eyeIconButton} type='button' onClick={() => { setShowPassword(!showPassword) }}>
                                                        {
                                                            !showPassword ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g opacity="0.6" clip-path="url(#clip0_897_1766)">
                                                                    <path d="M10.5846 10.5869C10.2096 10.9621 9.99893 11.4708 9.99902 12.0013C9.99912 12.5317 10.2099 13.0404 10.5851 13.4154C10.9602 13.7904 11.469 14.0011 11.9994 14.001C12.5299 14.0009 13.0386 13.7901 13.4136 13.4149" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M16.681 16.673C15.2782 17.5507 13.6547 18.0109 12 18C8.4 18 5.4 16 3 12C4.272 9.88003 5.712 8.32203 7.32 7.32603M10.18 6.18003C10.779 6.05876 11.3888 5.99845 12 6.00003C15.6 6.00003 18.6 8.00003 21 12C20.334 13.11 19.621 14.067 18.862 14.87" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M3 3L21 21" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_897_1766">
                                                                        <rect width="24" height="24" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g opacity="0.6">
                                                                    <path d="M2.06153 12.3479C1.97819 12.1234 1.97819 11.8764 2.06153 11.6519C2.87323 9.68373 4.25104 8.00091 6.0203 6.81677C7.78955 5.63263 9.87057 5.00049 11.9995 5.00049C14.1285 5.00049 16.2095 5.63263 17.9788 6.81677C19.748 8.00091 21.1258 9.68373 21.9375 11.6519C22.0209 11.8764 22.0209 12.1234 21.9375 12.3479C21.1258 14.316 19.748 15.9988 17.9788 17.183C16.2095 18.3671 14.1285 18.9993 11.9995 18.9993C9.87057 18.9993 7.78955 18.3671 6.0203 17.183C4.25104 15.9988 2.87323 14.316 2.06153 12.3479Z" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                </g>
                                                            </svg>

                                                        }

                                                    </button>

                                                </div>

                                            </div>
                                        </div>

                                        {/* CAPTCHA */}
                                        <div className={style.logincombine}>
                                            <label>Verification Captcha</label>
                                            <div className={style.captcha}>
                                                <div className={style.captchaandRecaptacha}>
                                                    <div className={style.captchvalue}>
                                                        <CaptchaCanvas text={generatedCaptcha} />
                                                    </div>
                                                    <img
                                                        src={process.env.PUBLIC_URL + "/NewPages/Homepage/recaptcha.png"}
                                                        alt="Captcha Reload"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={generateCaptcha}
                                                    />
                                                </div>

                                                <input
                                                    type="text"
                                                    placeholder="Type the characters above"
                                                    value={captcha}
                                                    onChange={(e) => setCaptcha(e.target.value)}
                                                    onPaste={(e) => { e.preventDefault(); }}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <button type="submit">{loading ? "Signing in..." : "Sign In"}</button>

                                        <div className={style.signupnavigator}>
                                            <p className={style.create}>Don’t have an account?</p>
                                            <Link to="/signup" style={{ color: "#f44f0d", fontWeight: "bold" }}> <u>Create an account</u></Link>
                                        </div>

                                    </form>
                                </div>
                            )
                        }
                        {
                            (forgetPassword && !verification) && (
                                <div style={{ gap: "0px" }} className={style.formcontainer}>
                                    <div style={{ textAlign: "center" }}>
                                        <h1>Forget Password</h1>

                                    </div>

                                    <form onSubmit={handleSignUp}>

                                        <div className={style.logincombine}>
                                            <label>Email *</label>
                                            <input
                                                type="email"
                                                placeholder="e.g. devdes@gmail.com"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </div>




                                        <button type="submit">SendCode</button>



                                    </form>
                                    <div className={style.signupnavigator}>
                                        <button style={{ background: "transparent", margin: "0px" }} onClick={() => { setForgetPassword(false); setEmail(""); setPassword(""); setCaptcha("") }}>
                                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.21967 4.99262C-0.0732233 5.28551 -0.0732233 5.76039 0.21967 6.05328L4.99264 10.8263C5.28553 11.1191 5.76041 11.1191 6.0533 10.8263C6.34619 10.5334 6.34619 10.0585 6.0533 9.76559L1.81066 5.52295L6.0533 1.28031C6.34619 0.987415 6.34619 0.512542 6.0533 0.219648C5.76041 -0.0732449 5.28553 -0.0732449 4.99264 0.219648L0.21967 4.99262ZM16.75 6.27295C17.1642 6.27295 17.5 5.93716 17.5 5.52295C17.5 5.10874 17.1642 4.77295 16.75 4.77295V5.52295V6.27295ZM0.75 5.52295V6.27295H16.75V5.52295V4.77295H0.75V5.52295Z" fill="#15141C" />
                                            </svg>
                                            <p className={style.forgetPassword}>


                                                Back</p>
                                        </button>

                                    </div>
                                </div>
                            )
                        }
                        {
                            verification && (
                                <div className={style.formcontainer}>
                                    <div style={{ textAlign: "center" }} >
                                        <h1>Check your email</h1>
                                        <p>Please enter the six digit verification code we sent to</p>
                                        <p style={{ color: "#15141C", fontSize: "16px", fontWeight: "500" }}>{email}</p>
                                    </div>

                                    <form onSubmit={verifycodeapi}>

                                        <div style={{ display: "flex", gap: "10px", padding: "40px", justifyContent: "center" }}>

                                            {otp.map((value, index) => (
                                                <input
                                                    key={index}
                                                    ref={(el) => (inputRefs.current[index] = el)}
                                                    type="text"
                                                    maxLength={1}
                                                    value={value}
                                                    onChange={(e) => handleChange(e.target.value, index)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                    onPaste={handlePaste}
                                                    onFocus={() => setActiveIndex(index)}
                                                    onBlur={() => setActiveIndex(null)}
                                                    style={{
                                                        width: "50px",
                                                        height: "50px",
                                                        textAlign: "center",
                                                        fontSize: "25px",
                                                        border: "2px solid " + (activeIndex === index ? "#5147C2" : "#D9D7DE"),
                                                        borderRadius: "8px",
                                                    }}
                                                />
                                            ))}
                                        </div>




                                        <button type="submit">Verify</button>



                                    </form>
                                    <div className={style.signupnavigator}>
                                        <button style={{ background: "transparent", margin: "0px" }} onClick={() => { setForgetPassword(true); setVerification(false); setEmail(""); setPassword(""); setCaptcha("") }}>
                                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.21967 4.99262C-0.0732233 5.28551 -0.0732233 5.76039 0.21967 6.05328L4.99264 10.8263C5.28553 11.1191 5.76041 11.1191 6.0533 10.8263C6.34619 10.5334 6.34619 10.0585 6.0533 9.76559L1.81066 5.52295L6.0533 1.28031C6.34619 0.987415 6.34619 0.512542 6.0533 0.219648C5.76041 -0.0732449 5.28553 -0.0732449 4.99264 0.219648L0.21967 4.99262ZM16.75 6.27295C17.1642 6.27295 17.5 5.93716 17.5 5.52295C17.5 5.10874 17.1642 4.77295 16.75 4.77295V5.52295V6.27295ZM0.75 5.52295V6.27295H16.75V5.52295V4.77295H0.75V5.52295Z" fill="#15141C" />
                                            </svg>
                                            <p className={style.forgetPassword}>


                                                Back</p>
                                        </button>

                                    </div>
                                </div>



                            )

                        }


                        {
                            (changingPassword && !verification) && (
                                <div className={style.formcontainer}>


                                    <form onSubmit={handleChangePassword}>

                                        <div className={style.logincombine}>
                                            <label>Password *</label>
                                            <div className={style.passwordContainer}>


                                                <input

                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Enter your password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required
                                                />
                                                <div className={style.eyeIcon} >
                                                    <button
                                                        aria-label={showPassword ? "Hide password" : "Show password"}
                                                        style={{ background: "transparent", margin: "0px" }} className={style.eyeIconButton} type='button' onClick={() => { setShowPassword(!showPassword) }}>
                                                        {
                                                            !showPassword ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g opacity="0.6" clip-path="url(#clip0_897_1766)">
                                                                    <path d="M10.5846 10.5869C10.2096 10.9621 9.99893 11.4708 9.99902 12.0013C9.99912 12.5317 10.2099 13.0404 10.5851 13.4154C10.9602 13.7904 11.469 14.0011 11.9994 14.001C12.5299 14.0009 13.0386 13.7901 13.4136 13.4149" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M16.681 16.673C15.2782 17.5507 13.6547 18.0109 12 18C8.4 18 5.4 16 3 12C4.272 9.88003 5.712 8.32203 7.32 7.32603M10.18 6.18003C10.779 6.05876 11.3888 5.99845 12 6.00003C15.6 6.00003 18.6 8.00003 21 12C20.334 13.11 19.621 14.067 18.862 14.87" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M3 3L21 21" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_897_1766">
                                                                        <rect width="24" height="24" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g opacity="0.6">
                                                                    <path d="M2.06153 12.3479C1.97819 12.1234 1.97819 11.8764 2.06153 11.6519C2.87323 9.68373 4.25104 8.00091 6.0203 6.81677C7.78955 5.63263 9.87057 5.00049 11.9995 5.00049C14.1285 5.00049 16.2095 5.63263 17.9788 6.81677C19.748 8.00091 21.1258 9.68373 21.9375 11.6519C22.0209 11.8764 22.0209 12.1234 21.9375 12.3479C21.1258 14.316 19.748 15.9988 17.9788 17.183C16.2095 18.3671 14.1285 18.9993 11.9995 18.9993C9.87057 18.9993 7.78955 18.3671 6.0203 17.183C4.25104 15.9988 2.87323 14.316 2.06153 12.3479Z" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                </g>
                                                            </svg>

                                                        }

                                                    </button>

                                                </div>

                                            </div>

                                        </div>
                                        <div className={style.logincombine}>
                                            <label>Confirm Password *</label>
                                            <div className={style.passwordContainer}>


                                                <input
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    placeholder="Enter your password"
                                                    value={confirmpassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                    required
                                                />
                                                <div className={style.eyeIcon} >
                                                    <button
                                                        aria-label={showConfirmPassword ? "Hide confirm password" : "Show confirm password"}
                                                        style={{ background: "transparent", margin: "0px" }} className={style.eyeIconButton} type='button' onClick={() => { setShowConfirmPassword(!showConfirmPassword) }}>
                                                        {
                                                            !showConfirmPassword ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g opacity="0.6" clip-path="url(#clip0_897_1766)">
                                                                    <path d="M10.5846 10.5869C10.2096 10.9621 9.99893 11.4708 9.99902 12.0013C9.99912 12.5317 10.2099 13.0404 10.5851 13.4154C10.9602 13.7904 11.469 14.0011 11.9994 14.001C12.5299 14.0009 13.0386 13.7901 13.4136 13.4149" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M16.681 16.673C15.2782 17.5507 13.6547 18.0109 12 18C8.4 18 5.4 16 3 12C4.272 9.88003 5.712 8.32203 7.32 7.32603M10.18 6.18003C10.779 6.05876 11.3888 5.99845 12 6.00003C15.6 6.00003 18.6 8.00003 21 12C20.334 13.11 19.621 14.067 18.862 14.87" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M3 3L21 21" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_897_1766">
                                                                        <rect width="24" height="24" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g opacity="0.6">
                                                                    <path d="M2.06153 12.3479C1.97819 12.1234 1.97819 11.8764 2.06153 11.6519C2.87323 9.68373 4.25104 8.00091 6.0203 6.81677C7.78955 5.63263 9.87057 5.00049 11.9995 5.00049C14.1285 5.00049 16.2095 5.63263 17.9788 6.81677C19.748 8.00091 21.1258 9.68373 21.9375 11.6519C22.0209 11.8764 22.0209 12.1234 21.9375 12.3479C21.1258 14.316 19.748 15.9988 17.9788 17.183C16.2095 18.3671 14.1285 18.9993 11.9995 18.9993C9.87057 18.9993 7.78955 18.3671 6.0203 17.183C4.25104 15.9988 2.87323 14.316 2.06153 12.3479Z" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                </g>
                                                            </svg>

                                                        }

                                                    </button>

                                                </div>

                                            </div>

                                        </div>

                                        <button type="submit">Change Password</button>



                                    </form>
                                    <div className={style.signupnavigator}>
                                        <button style={{ background: "transparent", margin: "0px" }} onClick={() => { setChangingPassword(false); setEmail(""); setPassword(""); setConfirmPassword(""); setCaptcha("") }}>
                                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.21967 4.99262C-0.0732233 5.28551 -0.0732233 5.76039 0.21967 6.05328L4.99264 10.8263C5.28553 11.1191 5.76041 11.1191 6.0533 10.8263C6.34619 10.5334 6.34619 10.0585 6.0533 9.76559L1.81066 5.52295L6.0533 1.28031C6.34619 0.987415 6.34619 0.512542 6.0533 0.219648C5.76041 -0.0732449 5.28553 -0.0732449 4.99264 0.219648L0.21967 4.99262ZM16.75 6.27295C17.1642 6.27295 17.5 5.93716 17.5 5.52295C17.5 5.10874 17.1642 4.77295 16.75 4.77295V5.52295V6.27295ZM0.75 5.52295V6.27295H16.75V5.52295V4.77295H0.75V5.52295Z" fill="#15141C" />
                                            </svg>
                                            <p className={style.forgetPassword}>


                                                Back</p>
                                        </button>

                                    </div>
                                </div>
                            )
                        }




                    </div>

                    <div className={style.signupimage}>
                        <img
                            src={process.env.PUBLIC_URL + "/NewPages/Homepage/LoginBackground.webp"}
                            alt="Login Background"
                        />
                    </div>

                </div>
            </div>
        </main>
    );
};

export default Loginnew;
